// filepath: src/features/widgets/useChatBookingBadgeEvent.ts
import { useEffect } from 'react';
import { storage } from '../configuration/setup/storage';
import { sendWindowMessage } from '../services/sendWindowMessage';
import { useGetUpsellingBadgeSeenStorageKey } from './useGetUpsellingBadgeSeenStorageKey';
import { gaPush } from '../configuration/setup/googleAnalytics';
import { useGetUpsellingCampaign } from './useGetUpsellingCampaign';

export const useAdvertisementSeen = (onScreen: boolean) => {
    const SEEN_KEY = useGetUpsellingBadgeSeenStorageKey();
    const upsellingCampaign = useGetUpsellingCampaign();

    useEffect(() => {
        if (!onScreen) {
            return;
        }

        const alreadySeen = storage.load(SEEN_KEY);
        const now = new Date().toISOString();
        if (!alreadySeen) {
            storage.save(SEEN_KEY, now);

            gaPush({
                category: upsellingCampaign.trackingCategory,
                action: 'Show upselling first time',
                label: 'Show order communication upselling advertisement first time',
            });
        } else {
            gaPush({
                category: upsellingCampaign.trackingCategory,
                action: 'Show upselling',
                label: 'Show order communication upselling advertisement',
            });
        }

        sendWindowMessage({
            type: 'EVENT_WIDGET_CHAT_TOTAL_UNREAD_MESSAGE_COUNT_CHANGED',
            payload: 0,
        });
    }, [onScreen, SEEN_KEY]);
};
